"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _debug = _interopRequireDefault(require("debug"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var styles = {
  "icon": "icon_3otNL1",
  "asset-image": "asset-image_3nC7FR",
  "assetImage": "asset-image_3nC7FR",
  "lg": "lg_1OCYGV",
  "md": "md_1hzEpu",
  "sm": "sm_11RaCk"
}; 
require('./Icon.css');
var log = (0, _debug.default)('exchange:AssetImage:component');
var sizeMap = {
  sm: 22,
  md: 44,
  lg: 66
};
var AssetIcon = function AssetIcon(_ref) {
  var alt = _ref.alt,
    size = _ref.size,
    icon = _ref.icon,
    onLoad = _ref.onLoad,
    onError = _ref.onError,
    type = _ref.type;
  var assetTypesConfiguration = (0, _react.useContext)(_exchangeReactHooks.AssetTypesConfigurationContext);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hasIconError = _useState2[0],
    setIconError = _useState2[1];
  var label = alt ? "".concat(alt, " icon") : null;
  if (icon && !hasIconError) {
    var handleError = function handleError(event) {
      log('An error has occurred while loading the image');
      setIconError(true);
      onError(event);
    };
    return /*#__PURE__*/_react.default.createElement("img", {
      "data-test-id": "asset-image",
      className: (0, _classnames.default)(styles.assetImage, styles[size]),
      loading: "lazy",
      src: icon,
      alt: label,
      onError: handleError,
      onLoad: onLoad
    });
  }
  var TypeIcon;
  if (assetTypesConfiguration[type]) {
    TypeIcon = assetTypesConfiguration[type].icon;
  } else {
    TypeIcon = assetTypesConfiguration.default.icon;
  }
  return /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    "aria-label": label,
    size: sizeMap[size]
  }, /*#__PURE__*/_react.default.createElement(TypeIcon, null));
};
AssetIcon.defaultProps = {
  size: 'md',
  onError: function onError() {},
  onLoad: function onLoad() {}
};
var _default = exports.default = AssetIcon;
//# sourceMappingURL=Icon.js.map